<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent({
    name: "global-filter-selected"
})
</script>

<template>
    <div class="global-filter-selected filter-selected">
        <div class="remove-filter remove-filter--secondary" @click="$emit('click')">
            <span><slot /></span>
            <span class="icon-remove"/>
        </div>
    </div>
</template>
